export default {
      id: "insured-person-usage",
      viewBox: "0 0 25 32",
      url: __webpack_public_path__ + "sprite.svg#insured-person",
      toString: function () {
        return this.url;
      }
    }